import type { CurrentUser, PermissionMap, RoleLookup } from './types';

/**
 * Pure permission evaluation used by the portal.
 *
 * A user is granted an action on a resource when *any* of their roles grants it.
 * A grant is either a static `true` or a predicate that must return `true` for
 * the supplied resource instance (e.g. "only the creator may update").
 */
export const evaluatePermission = <P extends PermissionMap, Resource extends keyof P>(
  roleLookup: RoleLookup<P>,
  user: CurrentUser,
  resource: Resource,
  action: P[Resource]['action'],
  data?: P[Resource]['dataType'],
): boolean =>
  user.roles.some((role) => {
    const resourcePermissions = roleLookup[role]?.[resource];
    const permission = resourcePermissions?.[action];
    if (permission == null) return false;
    if (typeof permission === 'boolean') return permission;
    return data != null && permission(user, data);
  });
